import React from "react"
import SanityBlockContent from "@sanity/block-content-to-react"
export default function BoatDescCard({ data, className }) {
  return (
    <div className={"w-full relative " + className}>
      <div className="px-2 lg:px-8 container mx-auto grid grid-cols-12 gap-4">
        <div className="col-span-12 xl:col-span-9">
          <div className="grid">
            <div>
              <h3 className="text-2xl font-semibold pb-4">
                {data.name}
              </h3>
              <div className="text-xs md:text-sm leading-5 md:leading-7 pb-4 grid lg:flex lg:justify-between">
                <div>
                  {data._rawDescription && (
                    <SanityBlockContent blocks={data._rawDescription} />
                  )}

                  {data._rawTemplate && (
                    <SanityBlockContent blocks={data._rawContent} />
                  )}
                </div>
                {data._rawPricing && (
                  <div className="pt-1 lg:pt-0">
                    <SanityBlockContent blocks={data._rawPricing} />
                  </div>
                )}
                {data._rawPricing && (
                  <div className="pt-1 lg:pt-0">
                    <SanityBlockContent blocks={data._rawPricing} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
